;
define("product_views_option_timeofday.tpl", function(){});

